import { TaskParticipant, CbmImpl } from "~/modules/cbm";
import { Action } from "~/modules/actions/Action";
import { getReservationsByTask, sendTrackingEvent } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";




export type GetTaskParticipantsResponse = Array<TaskParticipant>;



















export class GetTaskParticipants implements Action<Promise<GetTaskParticipantsResponse>> {
    


    readonly #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}): Promise<GetTaskParticipantsResponse> {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const worker = taskRouter.worker;

        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        logger.debug(`GetTaskParticipants invoked with taskSid: ${this.#taskSid}`);

        if (!worker) {
            const errorMsg = "GetTaskParticipants: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        
        
        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations?.[0];

        if (!reservation) {
            const errorMsg = `GetTaskParticipants: Reservation for task ${this.#taskSid} not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.GetTaskParticipantsCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        try {
            const participants = await cbm.getParticipantsByTask(reservation.task);

            sendTrackingEvent(EVENTS.GetTaskParticipantsCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });

            return Promise.resolve(participants);
        } catch (error) {
            const errorMsg = `GetTaskParticipants: Failed to get participants for task ${this.#taskSid}. ${
                error?.message
            }`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.GetTaskParticipantsCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
